import './App.css';
import 'antd/dist/reset.css';
import Mynav from './components/global/Navbar/Mynav';
import Home from './components/customs/Home';
import { Route, Routes } from 'react-router-dom';
import Admin from './components/customs/Admindashboard/Admin';
import AllBus from './components/customs/All-Buss/AllBus';
import Login from './components/customs/UserLogin/Login';
import Profile from './components/customs/Profile/Profile';
import Signup from './components/customs/Signup.js/Signup';
import Ticket from './components/customs/MyTickets/Ticket.js';
import FAQSection from './components/customs/FAQ.js';
import { useEffect, useState } from 'react';
import axios from 'axios';




// import { useSelector } from 'react-redux';
import store from '../src/store/store'
import { userdetails } from '../src/store/actions/actionType.js';
import Userauth from './components/customs/UserAuth/Userauth.js';
import AdminStata from './components/customs/AdminComponent/Users/AdminStata.js';
import AdminTest from './components/customs/Admindashboard/AdminTest.js';

const backend_url = process.env.REACT_APP_BACKEND_URL


function App() {




  const [user, setUser] = useState(null);
  // const myData =  useSelector(data => data.userdetailreducer)

  





  useEffect(() => {
    const fetchUserData = async () => {
      console.log('inside useeffect func')
      try {
        // Get the username from localStorage
        const username = localStorage.getItem('username');
        console.log(username)

            // Check if username exists
            if (!username) {
                console.log('No username found in localStorage');
                return;
            }

            // Make API call
              // const response = await axios.get('http://localhost:8000/api/user-details', {
              const response = await axios.get(`${backend_url}/api/user-details`, {
                params: { username: username, email: username },
              });
    

            // Set user data
            setUser(response.data);
            
            
            



             const { fname, email, mobile,ticketNumbers } = response.data.user;

              // console.log('from the app.js ',response.data.user)

            store.dispatch(userdetails({username,email,fname,mobile,ticketNumbers}))



        } catch (err) {
            console.error('Error fetching user:', err);
        }
    };



    // Call the function to fetch user data
    fetchUserData();
}, []); 











const admintoken = localStorage.getItem('admintoken');




  return (
    <>
      {!admintoken?<Mynav />:null}
      <Routes>

        <Route path='/' element={<Home />} />
        <Route path='/home' element={<Home />} />
        
        <Route path='/auth' element={<Userauth />} />
        {/* <Route path='/login' element={<Login />} />
        <Route path='/signup' element={<Signup />} /> */}
        <Route path='/admin' element={<Admin />} />
        {/* <Route path='/admin' element={<AdminTest />} /> */}
        <Route path='/all-buses' element={<AllBus />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/trips' element={<Profile  />} />
        <Route path='/ticket' element={<Ticket/>} />
        <Route path='/faq' element={<FAQSection/>} />
        <Route path='/addstata' element={<AdminStata/>} />


      </Routes>

    </>
  );
}

export default App;
